import { React } from 'mcelroy-lib'

/*
    Wrap Cloudflare Turnstile Captcha in a React hook
*/
export function useTurnstile() {
    const wrapperRef = React.useRef(null)
    const turnstile = React.useRef(null)

    // Load Google ReCaptcha
    React.useEffect(() => {
        if (wrapperRef?.current)
            turnstile.current = setupTurnstile(wrapperRef.current)
    }, [wrapperRef])

    return { wrapperRef, turnstile }
}

/*
    Turnstile uses the same API as Google's ReCaptcha...
    Wrap Google's horrible recaptcha API in a Promise.

    First time:
    execute has to be called to calculate the token and it calls the callback: tokenGenerated
    getResponse returns ""

    Next time:
    execute does nothing and doesn't call the callback if the token is not expired
    getResponse returns the token

    If token is expired it acts like First time.

    The Promise hides all of this mess.
*/
export function setupTurnstile(element) {
    let widget = null
    let resolveFun = null

    function loadTurnstile() {
        widget = turnstile.render(element, {
            'sitekey': '0x4AAAAAABkQnuEf7kHWmODL',
            'size': 'flexible',
            'callback': tokenGenerated
        })
    }

    if (turnstile?.render)
        loadTurnstile()
    else
        setTimeout(loadTurnstile, 1000)

    function tokenGenerated(token) {
        resolveFun?.(token)
    }

    function getToken(internal) {
        return new Promise(function (resolve, fail) {
            if (internal === true) {
                resolve('internal')
            } else {
                resolveFun = resolve
                turnstile.execute(widget)
                const token = turnstile.getResponse(widget)
                if (token && token != "")
                    resolve(token)
                else
                    setTimeout(function () { fail('Captcha Timeout') }, 60000)
            }
        })
    }

    function reset() {
        turnstile.reset(widget)
    }

    return {
        getToken,
        reset
    }
}
